var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1629720d-294f-4331-a610-91bf7ce7363f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "38d89055-0ba7-4135-a85a-b39d2b5aae1b",
    y1: 50.83,
    x2: 215,
    y2: 50.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff638a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Peaking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,140H0V68s119.38.25,126.88,0c10-.25,6.71-32.92,15.46-33.33s5.49,32,15.41,33.33H215Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67H125.21c15.79,0,6.13-32.33,17.13-32.33,11.16,0,4,32.33,17.16,32.33H215",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#38d89055-0ba7-4135-a85a-b39d2b5aae1b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaking);
export default __webpack_public_path__ + "static/media/Peaking.a6b919b9.svg";
export { ForwardRef as ReactComponent };